var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPickUp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#EF7B22"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_567_3238)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1094 15.0164C29.1902 15.4992 29.9861 16.7159 30.9841 18.3906H27.1094V15.0164ZM14.949 18.5312C15.3564 18.5312 15.6521 18.7279 15.6521 19.1875C15.6521 19.5751 15.3384 19.8895 14.951 19.8906H10.7031C10.3148 19.8906 10 20.2056 10 20.5938C10 20.9821 10.3148 21.2969 10.7031 21.2969H17.0312C17.4233 21.2969 17.7371 21.6115 17.7371 22C17.7371 22.3884 17.4224 22.7031 17.034 22.7031H10.7031C10.3148 22.7031 10 23.0179 10 23.4062C10 23.7946 10.3148 24.1094 10.7031 24.1094H12.25V26.2188C12.25 26.6071 12.5648 26.9219 12.9531 26.9219H14.3665C14.6185 28.163 15.7151 29.0781 17.0078 29.0781C18.3005 29.0781 19.3972 28.163 19.6491 26.9219H26.7884C27.0403 28.163 28.137 29.0781 29.4297 29.0781C30.7224 29.0781 31.819 28.163 32.071 26.9219H33.2969C33.6852 26.9219 34 26.6071 34 26.2188V22C34 19.937 31.824 19.8 31.822 19.7969H26.4062C26.0179 19.7969 25.7031 19.4821 25.7031 19.0938V14.875H12.9531C12.5648 14.875 12.25 15.1898 12.25 15.5781V17.125H11.4062C11.0179 17.125 10.7031 17.4398 10.7031 17.8281C10.7031 18.2165 11.0179 18.5312 11.4062 18.5312H14.949ZM30.3412 25.4713C30.8445 25.9747 30.8445 26.7911 30.3412 27.2945C29.5315 28.1042 28.1406 27.5281 28.1406 26.3828C28.1406 25.2377 29.5315 24.6616 30.3412 25.4713ZM17.9193 25.4713C18.4227 25.9747 18.4227 26.7911 17.9193 27.2945C17.1096 28.1042 15.7188 27.5281 15.7188 26.3828C15.7188 25.2377 17.1096 24.6616 17.9193 25.4713Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_567_3238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(10 10)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPickUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pick-up.da7769f4ca01b7728043164bd59a7869.svg";